const No = () =>{
  return(
    <div>
      <h6 style={{fontWeight: '600', textAlign: 'center', marginTop: '25px'}}>Thank you for your selection</h6>
    </div>
  )
}
export default No